import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Story from "@/components/landing/Story";
import StatsStrip from "@/components/landing/StatsStrip";
import Reviews from "@/components/landing/Reviews";
import Award from "@/components/landing/Award";
import Products from "@/components/landing/Products";
import LeadForm from "@/components/landing/LeadForm";
import Footer from "@/components/landing/Footer";
import { setLenis } from "@/components/landing/shared";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="noise min-h-screen bg-white font-body text-stone-900 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Story />
        <StatsStrip />
        <Award />
        <Products />
        <Reviews />
        <LeadForm />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
